export default __webpack_public_path__ + "static/media/img (2).f1dd9fca.jpg";